import { get, post, put, del } from 'common/axiosClient';
import {
  BulkDeleteCCReportsDTO,
  CCReport,
  CCReportComp,
  CCReportExportData,
  CCReportInfo,
  DeleteCCReportCompsDTO,
  InputCCReportDTO,
  addCompsToCCReportDTO,
  costPerDivision,
  CCReportInvoiceDTO,
  CreateCCReportInvoiceDTO,
  UpdateCCReportInvoiceDTO,
} from './construction-cost-report.type';
import { API } from '../../common/constants/urls';
import { NoteDTO } from 'common/utils/util.type';

export const getCCReports = async (queryParams: string[]) => {
  const queryString = queryParams.join('&');
  return (await get(`${API.CONSTRUCTION_COST_REPORTS}?${queryString}`)) as { total: number; reportsList: CCReportInfo[] };
};

export const getCCReport = async (reportId: string) => {
  return (await get(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}`)) as CCReport;
};
export const getCostPerDivision = async (reportId: string) => {
  return (await get(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/cost-per-division`)) as costPerDivision;
};

export const createCCReport = async (requestDto: InputCCReportDTO) => {
  return (await post(API.CONSTRUCTION_COST_REPORTS, requestDto)) as CCReport;
};

export const updateCCReport = async (reportId: string, requestDto: InputCCReportDTO) => {
  return (await put(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}`, requestDto)) as CCReport;
};

export const deleteCCReport = async (reportId: string) => {
  return (await del(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}`)) as string;
};

export const bulkDeleteCCReports = async (dto: BulkDeleteCCReportsDTO) => {
  return (await post(`${API.CONSTRUCTION_COST_REPORTS}/bulk-delete`, dto)) as string;
};

export const updateCCReportComps = async (reportId: string, comps: CCReportComp[]) => {
  return (await put(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/comps`, comps)) as CCReport;
};
export const addCompsToCCReport = async (inputDTO: addCompsToCCReportDTO) => {
  return await post(`${API.CONSTRUCTION_COST_REPORTS}/add-comps`, inputDTO);
};
export const addOrUpdateNoteToReport = async (reportId: string, requestDto: NoteDTO) => {
  return await put(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/notes`, requestDto);
};
export const getNotes = async (reportId: string) => {
  return await get(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/notes`);
};
export const deleteNoteFromReport = async (reportId: string, noteId: string) => {
  return await del(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/notes/${noteId}`);
};

export const deleteCCReportComps = async (dto: DeleteCCReportCompsDTO) => {
  return await post(`${API.CONSTRUCTION_COST_REPORTS}/del-comps`, dto);
};
export const exportCCReportAsWord = async (data: CCReportExportData) => {
  return await post(`${API.CONSTRUCTION_COST_REPORTS}/export-word`, data, {
    responseType: 'blob',
  });
};

export const duplicateCCReport = async (reportId: string, reportName: string): Promise<CCReport> => {
  const requestBody = { reportName };
  const response = await post(`${API.CONSTRUCTION_COST_REPORTS}/${reportId}/duplicate`, requestBody);
  return response as CCReport;
};

// Invoice API functions for CC Reports
export const createCCReportInvoice = async (createDto: CreateCCReportInvoiceDTO): Promise<CCReportInvoiceDTO> => {
  return (await post(`${API.CONSTRUCTION_COST_REPORTS}/${createDto.ccReportId}/invoices`, createDto)) as CCReportInvoiceDTO;
};

export const getCCReportInvoices = async (ccReportId: string): Promise<CCReportInvoiceDTO[]> => {
  return (await get(`${API.CONSTRUCTION_COST_REPORTS}/${ccReportId}/invoices`)) as CCReportInvoiceDTO[];
};

export const getCCReportInvoice = async (invoiceId: string): Promise<CCReportInvoiceDTO> => {
  return (await get(`${API.CONSTRUCTION_COST_REPORTS}/invoice/${invoiceId}`)) as CCReportInvoiceDTO;
};

export const updateCCReportInvoice = async (invoiceId: string, updateDto: UpdateCCReportInvoiceDTO): Promise<CCReportInvoiceDTO> => {
  return (await put(`${API.CONSTRUCTION_COST_REPORTS}/invoice/${invoiceId}`, updateDto)) as CCReportInvoiceDTO;
};

export const deleteCCReportInvoice = async (invoiceId: string): Promise<string> => {
  return (await del(`${API.CONSTRUCTION_COST_REPORTS}/invoice/${invoiceId}`)) as string;
};
